function collectionLinkListScroller() {

  let collectionLinkListWidth = document.querySelector('.collection-link-list').offsetWidth;

  const collectionCardScroller = document.getElementById('collectionLinkList');
  const collectionCards = document.querySelectorAll('.collection-link-list--item');
  const collectionCardLength = collectionCards.length;
  const collectionCardScrollerButtons = document.getElementById('collectionLinkListButtons');

  if (collectionLinkListWidth < 1400 && collectionCardLength > 6) {
    collectionCardScrollerButtons.classList.add('is-visible');
  } else if (collectionCardLength > 7) {
    collectionCardScrollerButtons.classList.add('is-visible');
  }
  
  const scrollButtonRight = document.getElementById("collectionLinkListScrollRight");
  const scrollButtonLeft = document.getElementById("collectionLinkListScrollLeft");
  
  scrollButtonRight.onclick = () => {
    document.getElementById("collectionLinkList").scrollLeft += 180;
  };
  
  scrollButtonLeft.onclick = () => {
    document.getElementById("collectionLinkList").scrollLeft -= 180;
  };
};
collectionLinkListScroller();